import { checkAuthorizationView } from '../services/authorization-service';
import logList from '../pages/log/list';
import warrantyList from '../pages/warranty/list';
import EditwarrantyForm from '../pages/warranty/edit';

import serviceList from '../pages/service/list';
import EditServiceForm from '../pages/service/edit';

import riskList from '../pages/risk/list';
import EditRiskForm from '../pages/risk/edit';

import insuranceList from '../pages/insurance/list';
import EditInsuranceForm from '../pages/insurance/edit';

import healthPlanList from '../pages/health-plan/list';
import EditHealthPlanForm from '../pages/health-plan/edit';

import regionList from '../pages/region/list';
import EditRegionForm from '../pages/region/edit';

import communeList from '../pages/commune/list';
import EditCommuneForm from '../pages/commune/edit';

export const INSURANCE_LIST_PATH = '/insurance/list/';
export const INSURANCE_ADD_PATH = '/insurance/add/';
export const INSURANCE_EDIT_PATH = '/insurance/edit/:id/';

export const WARRANTY_LIST_PATH = '/warranty/list/';
export const WARRANTY_ADD_PATH = '/warranty/add/';
export const WARRANTY_EDIT_PATH = '/warranty/edit/:id/';

export const SERVICE_LIST_PATH = '/service/list/';
export const SERVICE_ADD_PATH = '/service/add/';
export const SERVICE_EDIT_PATH = '/service/edit/:id/';

export const RISK_LIST_PATH = '/risk/list/';
export const RISK_ADD_PATH = '/risk/add/';
export const RISK_EDIT_PATH = '/risk/edit/:id/';

export const HEALTH_PLAN_LIST_PATH = '/health-plan/list/';
export const HEALTH_PLAN_ADD_PATH = '/health-plan/add/';
export const HEALTH_PLAN_EDIT_PATH = '/health-plan/edit/:id/';

export const REGION_LIST_PATH = '/region/list/';
export const REGION_ADD_PATH = '/region/add/';
export const REGION_EDIT_PATH = '/region/edit/:id/';

export const COMMUNE_LIST_PATH = '/commune/list/';
export const COMMUNE_ADD_PATH = '/commune/add/';
export const COMMUNE_EDIT_PATH = '/commune/edit/:id/';

export const LOG_LIST_PATH = '/logs/list/';

export const LOG_PATHS = [
  {
    path: LOG_LIST_PATH,
    exact: true,
    component: checkAuthorizationView(logList, ['LOG_LIST'])
  }
];

export const INSURANCE_PATHS = [
  {
    path: INSURANCE_LIST_PATH,
    exact: true,
    component: checkAuthorizationView(insuranceList, ['INSURANCE_LIST'])
  },
  {
    path: INSURANCE_ADD_PATH,
    exact: true,
    component: checkAuthorizationView(EditInsuranceForm, ['ADD_INSURANCE'])
  },
  {
    path: INSURANCE_EDIT_PATH,
    exact: true,
    component: checkAuthorizationView(EditInsuranceForm, ['EDIT_INSURANCE'])
  }
];

export const WARRANTY_PATHS = [
  {
    path: WARRANTY_LIST_PATH,
    exact: true,
    component: checkAuthorizationView(warrantyList, ['WARRANTY_LIST'])
  },
  {
    path: WARRANTY_ADD_PATH,
    exact: true,
    component: checkAuthorizationView(EditwarrantyForm, ['ADD_WARRANTY'])
  },
  {
    path: WARRANTY_EDIT_PATH,
    exact: true,
    component: checkAuthorizationView(EditwarrantyForm, ['EDIT_WARRANTY'])
  }
];

export const SERVICE_PATHS = [
  {
    path: SERVICE_LIST_PATH,
    exact: true,
    component: checkAuthorizationView(serviceList, ['SERVICE_LIST'])
  },
  {
    path: SERVICE_ADD_PATH,
    exact: true,
    component: checkAuthorizationView(EditServiceForm, ['ADD_SERVICE'])
  },
  {
    path: SERVICE_EDIT_PATH,
    exact: true,
    component: checkAuthorizationView(EditServiceForm, ['EDIT_SERVICE'])
  }
];

export const RISK_PATHS = [
  {
    path: RISK_LIST_PATH,
    exact: true,
    component: checkAuthorizationView(riskList, ['RISK_LIST'])
  },
  {
    path: RISK_ADD_PATH,
    exact: true,
    component: checkAuthorizationView(EditRiskForm, ['ADD_RISK'])
  },
  {
    path: RISK_EDIT_PATH,
    exact: true,
    component: checkAuthorizationView(EditRiskForm, ['EDIT_RISK'])
  }
];

export const HEALTH_PLAN_PATHS = [
  {
    path: HEALTH_PLAN_LIST_PATH,
    exact: true,
    component: checkAuthorizationView(healthPlanList, ['HEALTH_PLAN_LIST'])
  },
  {
    path: HEALTH_PLAN_ADD_PATH,
    exact: true,
    component: checkAuthorizationView(EditHealthPlanForm, ['ADD_HEALTH_PLAN'])
  },
  {
    path: HEALTH_PLAN_EDIT_PATH,
    exact: true,
    component: checkAuthorizationView(EditHealthPlanForm, ['EDIT_HEALTH_PLAN'])
  }
];

export const REGION_PATHS = [
  {
    path: REGION_LIST_PATH,
    exact: true,
    component: checkAuthorizationView(regionList, ['REGION_LIST'])
  },
  {
    path: REGION_ADD_PATH,
    exact: true,
    component: checkAuthorizationView(EditRegionForm, ['ADD_REGION'])
  },
  {
    path: REGION_EDIT_PATH,
    exact: true,
    component: checkAuthorizationView(EditRegionForm, ['EDIT_REGION'])
  }
];

export const COMMUNE_PATHS = [
  {
    path: COMMUNE_LIST_PATH,
    exact: true,
    component: checkAuthorizationView(communeList, ['COMMUNE_LIST'])
  },
  {
    path: COMMUNE_ADD_PATH,
    exact: true,
    component: checkAuthorizationView(EditCommuneForm, ['ADD_COMMUNE'])
  },
  {
    path: COMMUNE_EDIT_PATH,
    exact: true,
    component: checkAuthorizationView(EditCommuneForm, ['EDIT_COMMUNE'])
  }
];

export const maintainerFormRouters = [
  ...WARRANTY_PATHS,
  ...SERVICE_PATHS,
  ...RISK_PATHS,
  ...INSURANCE_PATHS,
  ...HEALTH_PLAN_PATHS,
  ...REGION_PATHS,
  ...COMMUNE_PATHS
];

export const otherRouters = [...LOG_PATHS];
